import { TaxRatesEntity } from "src/@types/catalog/taxRates";

interface GetTaxRatesProps {
  taxRates: TaxRatesEntity[] | null;
  taxId: string;
}

export const COMPLIANCE_STANDARD = {
  VeriFactu: 0,
  SII: 1,
  SDI: 2,
  FrancePA: 3,
};

export const COMPLIANCE_STANDARD_DOCUMENT_TYPE = {
  REGULAR_INVOICE: 0,
  SIMPLIFIED_INVOICE: 1,
  CREDIT_NOTE: 2,
  DEBIT_NOTE: 3,
  CORRECTIVE_INVOICE: 4,
  CANCEL_INVOICE: 5,
};

export const VERIFACTU_CORRECTION_DOCUMENT_TYPE = {
  SUBSTITUTION: 0,
  RECTIFICATION: 1,
  CANCELATION: 2,
};

export const getTaxRate = ({
  taxRates,
  taxId,
}: GetTaxRatesProps): TaxRatesEntity | null =>
  taxRates?.find((taxRate) => taxRate.taxId === taxId) ?? null;
